import {
  API_ERROR,
  PRODUCTS,
  PRODUCT_GROUPS,
  PRODUCT_CHANGEVALUE,
  PPRODUCT_SELECT_CHANGEVALUE,
  BASEUNIT_SELECT_CHANGEVALUE,
  PRODUCT_UNITS_VALUE,
  PRODUCT_VENDORS_VALUE,
  PRODUCT_IMAGE,
  PRODUCT_GROUP_VALUE,
  GET_PRODUCT_ROW_DATA,
  GROUP_CHANGEVALUE,
  PRODUCTGROUP_LIST_SUCCESSFUL,
  PRODUCT_ADD,
  PRODUCT_DELETE,
  MODEL_OPEN,
  MODEL_CLOSE,
  PRODUCT_LIST_SUCCESSFUL,
  PRODUCT_ADD_SUCCESSFUL,
  PRODUCT_ROW_SUCCESSFUL,
  SET_PARAMS,
  UNITS_MODEL_OPEN,
  UNITS_MODEL_CLOSE,
  UNITS_CHANGEVALUE,
  DELETE_UNITS_ROW,
  MR_CUSTOM_PRODUCT,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  rowlist: [],
  units: [],
  vendor_ids: [],
  unitsModel: false,
  error_msg: null,
  rowdata: {
    vendors: [],
    units: [],
    description: "",
  },
  ProductUnits: {},
  image: {},
  grouprowdata: {},

  grouplist: [],
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
};

const products = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_GROUPS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PRODUCTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PRODUCT_LIST_SUCCESSFUL:
      var noofpages = Math.ceil(
        action.payload.response.count / state.params.page_size
      );
      state = {
        ...state,
        rowlist: action.payload.response.results,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
      };
      break;
    case PRODUCT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case PPRODUCT_SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case BASEUNIT_SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
          units: [
            {
              name: action.payload.label,
              units: 1,
              dodelete: false,
            },
          ],
        },
      };
      break;
    case UNITS_CHANGEVALUE:
      state = {
        ...state,
        ProductUnits: {
          ...state.ProductUnits,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case DELETE_UNITS_ROW:
      var filterUnits = state.rowdata.units.filter(
        (units, i) => i !== action.payload.index
      );
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          units: filterUnits,
        },
      };
      break;
    case PRODUCT_VENDORS_VALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          vendors: action.payload.Pvendors,
        },
      };
      break;
    case PRODUCT_IMAGE:
      state = {
        ...state,
        image: action.payload.Pimage,
      };
      break;
    case PRODUCT_UNITS_VALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          units: [
            ...state.rowdata.units,
            {
              name: action.payload.name,
              units: action.payload.units,
              dodelete: action.payload.dodelete,
            },
          ],
        },
        unitsModel: false,
        ProductUnits: {},
      };
      break;
    case PRODUCT_GROUP_VALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          group_id: action.payload.Pgroup,
        },
      };
      break;
    case PRODUCT_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case PRODUCT_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
      };
      break;
    case GET_PRODUCT_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PRODUCT_ROW_SUCCESSFUL:
      state = {
        ...state,
        rowdata: action.payload.response,
        loading: false,
      };
      break;
    case MR_CUSTOM_PRODUCT:
      state = {
        ...state,
        rowdata: action.payload,
        loading: false,
      };
      break;
    case GROUP_CHANGEVALUE:
      state = {
        ...state,
        grouprowdata: {
          ...state.grouprowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;

    case PRODUCTGROUP_LIST_SUCCESSFUL:
      state = {
        ...state,
        grouplist: action.payload.response,
        loading: false,
        model: false,
        grouprowdata: {},
      };
      break;

    case PRODUCT_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
      };
      break;
    case UNITS_MODEL_OPEN:
      state = {
        ...state,
        unitsModel: true,
      };
      break;
    case UNITS_MODEL_CLOSE:
      state = {
        ...state,
        unitsModel: false,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default products;
